import { Tabs, Typography, Card } from 'antd';
import {
  BgColorsOutlined,
  AppstoreOutlined,
  SettingOutlined
} from '@ant-design/icons';
import AppearanceSettings from '../components/AppearanceSettings';
import AppConfigurationSettings from '../components/AppConfigurationSettings';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

const SettingsPage = () => {
  return (
    <div style={{ padding: '24px' }}>
      {/* Header */}
      <div style={{ marginBottom: '24px' }}>
        <Title level={2} style={{ marginBottom: '8px' }}>
          Settings
        </Title>
        <Text type="secondary">
          Configure your application appearance, sidebar, and preferences
        </Text>
      </div>

      {/* Tabs Container */}
      <Card>
        <Tabs defaultActiveKey="appearance" type="card">
          {/* Appearance Tab */}
          <TabPane
            tab={
              <span>
                <BgColorsOutlined />
                Appearance
              </span>
            }
            key="appearance"
          >
            <div style={{ padding: '16px' }}>
              <AppearanceSettings />
            </div>
          </TabPane>

          {/* Sidebar Configuration Tab */}
          <TabPane
            tab={
              <span>
                <AppstoreOutlined />
                Sidebar Configuration
              </span>
            }
            key="sidebar"
          >
            <div style={{ padding: '16px' }}>
              <div style={{ marginBottom: '16px' }}>
                <Text type="secondary">
                  Manage your application sidebar menu items. Drag and drop to reorder, toggle to enable/disable items.
                </Text>
              </div>
              <AppConfigurationSettings
                applicationFilter="app"
                defaultApplication="app"
              />
            </div>
          </TabPane>

          {/* General Settings Tab */}
          <TabPane
            tab={
              <span>
                <SettingOutlined />
                General
              </span>
            }
            key="general"
          >
            <div style={{ padding: '16px' }}>
              <Title level={4}>General Settings</Title>
              <Text type="secondary">
                Additional application settings will be implemented here.
              </Text>
            </div>
          </TabPane>
        </Tabs>
      </Card>
    </div>
  );
};

export default SettingsPage;
